import React from 'react';

import { Cog } from 'lucide-react';

import { cn } from './utils';


const SIZE_CLASS = {
  sm: 'size-4',
  md: 'size-6',
  lg: 'size-8',
};


/**
 * Rotating gear spinner — mirrors the app's `Loader2 animate-spin` idiom
 * (ui/Button.jsx, Logout.jsx) but with the brand `Cog`. Sizes: sm ~16px,
 * md ~24px, lg ~32px. Defaults to `text-primary`; pass `className` to recolor
 * (e.g. `text-on-primary` on a gradient surface).
 */
const Spinner = React.forwardRef((props, ref) => {
  const { className, size = 'md', ...restProps } = props;

  return (
    <Cog
      ref={ref}
      aria-hidden="true"
      className={cn('animate-spin text-primary', SIZE_CLASS[size] || SIZE_CLASS.md, className)}
      {...restProps}
    />
  );
});

Spinner.displayName = 'Spinner';

export { Spinner };
export default Spinner;
